import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_fallback_on_payment_male_us~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_us/web_fallback_on_payment_male_us__male'),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_fallback_on_payment_male_us~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_us/web_fallback_on_payment_male_us__male_walking'),
			},
		},
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_fallback_on_payment_male_us~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_us/web_fallback_on_payment_male_us__male_tai_chi_yoga'),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_fallback_on_payment_male_us~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_us/web_fallback_on_payment_male_us__male_chair_workouts'),
			},
		},
	},
]

export default config
